import CommonImages from "../images";

export const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
}

export const capitalizeFirstLetter = (val) => {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

// This map is based on the V1 widget settings
export const calendarMap = {
    google: {
        logo: CommonImages.GOOGLE_LOGO,
        name: 'Google',
        icsLinkKey: 'googleUrl',
    },
    android: {
        logo: CommonImages.ANDROID_LOGO,
        name: 'Android',
        icsLinkKey: 'googleUrl',
    },
    apple: {
        logo: CommonImages.APPLE_LOGO,
        name: 'Apple',
        icsLinkKey: 'appleCalUrl',
    },
    outlook: {
        logo: CommonImages.OUTLOOK_LOGO,
        name: 'Classic Outlook (Desktop)',
        icsLinkKey: 'appleCalUrl',
    },
    'outlook-new': {
        logo: CommonImages.NEW_OUTLOOK,
        name: 'New Outlook (Desktop)',
        icsLinkKey: 'appleCalUrl',
    },
    ics_other: {
        logo: CommonImages.OTHER_LOGO,
        name: 'Other',
        icsLinkKey: 'appleCalUrl',
    },
    office365: {
        logo: CommonImages.OFFICE365_LOGO,
        name: 'Microsoft 365',
        icsLinkKey: 'outlookcomUrl',
    },
    windowslive: {
        logo: CommonImages.OUTLOOK_LOGO,
        name: 'Outlook.com (Web)',
        icsLinkKey: 'outlookcomUrl',
    },
};

export const getCalendarLogo = (cal) => {
    return calendarMap[cal]?.logo;
}

export const getCalendarName = (cal) => {
    return calendarMap[cal]?.name;
}

export const getIcsLinkKey = (cal) => {
    return calendarMap[cal]?.icsLinkKey;
}
